import { ListOfLanguages } from "./Languages.enum";

const languageLabels: Record<ListOfLanguages, string> = {
  [ListOfLanguages.EN]: "EN",
  [ListOfLanguages.PT]: "PT",
};

export const languages = Object.values(ListOfLanguages).map((value) => ({
  value,
  label: languageLabels[value],
}));